import React, { Fragment } from "react";
import { Label, Input } from "reactstrap";

const CheckboxField = (props) => {
  const {
    input: { value, onChange, onBlur, name, type },
    meta: { touched, error, warning },
    label,
    placeholder,
    readonly,
    disabled,
    bgColor,
    className,
    errorName,
    ...rest
  } = props;

  return (
    <div>
      <Input
        onChange={onChange}
        onBlur={onBlur}
        checked={_.isBoolean(value) ? value : false}
        type="checkbox"
        placeholder={placeholder}
        readOnly={readonly}
        disabled={disabled}
        style={{ backgroundColor: bgColor }}
        className={className}
        name={name}
        value={value}
        {...rest}
      />
      {label && (
        <Label className="ml-2" style={{ textDecoration: value ? "line-through" : "none" }}>
          {label}
        </Label>
      )}
      {touched && ((error && <span className="text-danger">- {error}</span>) || (warning && <span className="text-warning">{warning}</span>))}
    </div>
  );
};

export default CheckboxField;
